import React, {
  lazy,
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { LazyImage } from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { getTrans as T } from "../../../../Shared/Language";
import { TostMsg } from "../../../../App";
import {
  deleteEmployeeAwards,
  getEmployeeAwards,
} from "../../AwardList/Services/awardService";
import {
  useHistory,
} from "react-router-dom/cjs/react-router-dom.min";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import { getRawPermissionsArray } from "../../../../Routes/AuthGard/usePermissions";
const ComponentLoader = React.memo(
  lazy(() => import("../../../../Shared/Sidebar/ComponentLoader"))
);

const UserAward = ({ employeeId, employee }) => {
  const [awardsEditId, setAwardsEditId] = useState(null);
  const [awardList, setAwardList] = useState([]);
  const [Isloading, setIsloading] = useState(false);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let toster = useContext(TostMsg);
  const [deleteContent, setSeleteContent] = useState([]);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  let userPermissions = getRawPermissionsArray();
  const [create, setCreate] = useState(false);
  const [update, setUpdate] = useState(false);
  const [deleted, setDeleted] = useState(false);
  let history = useHistory();

  useEffect(() => {
    if (employeeId > 0) {
      getEmployeeAwardData();
      permissionGiven();
    }
  }, [employeeId]);

  const permissionGiven = () => {
    userPermissions?.map((UserPermission) => {
      if (UserPermission.PermissionName == "Award.Create") {
        setCreate(true);
      } else if (UserPermission.PermissionName == "Award.Update") {
        setUpdate(true);
      } else if (UserPermission.PermissionName == "Award.Delete") {
        setDeleted(true);
      }
    });
  };

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setSeleteContent(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setSeleteContent(msg?.Desc);
      }
    });
  }, []);



  const getEmployeeAwardData = async () => {
    let body = {
      OrgId: userDetails.OrgId,
      LoggedInUserId: employeeId,
      year: "",
      AwardNumber: "",
      Awardid: 0,
      PageNumber: 1,
      PageSize: 100,
    };
    try {
      let response = await getEmployeeAwards(body);
      setAwardList(response?.Data);
    } catch (err) {
      setIsloading(false);
    }
  };

  const handleCreatedlstDelete = (Id) => {
    setAwardsEditId(Id);
  };

  async function DeleteOrgAwardsAward() {
    setIsloading(true);
    if (awardsEditId) {
      let body = {
        Id: awardsEditId,
        ModifiedBy: userDetails?.EmpId,
      };
      setIsloading(true);
      try {
        let awardDeleteList = await deleteEmployeeAwards(body);
        if (awardDeleteList) {
          GetMasterSystemAlertList("Award_Deleted", 0);
          setIsloading(false);
          getEmployeeAwardData();
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }
  }

  const addAward = () => {
    history.push(`/Add/Award/${employee[0]?.GUID}`);
  };

    async function editawards(awardDetails) {
    history.push(`/Edit/Award/${awardDetails?.AwardNumber}`);
  }
  
  return (
    <div>
      <div className="profile-about-me">
        <div className="pt-3 border-bottom-1">
          <div className="mb-0">
            <h4 className="text-primary mb-3 sumh4 addprofile-action">
              {T("Awards")}
              {create && (
                <span>
                  <a
                    className="edit-btncss mb-2 love-icon"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Add Award"
                    data-bs-toggle="modal"
                    onClick={() => {
                      addAward();
                    }}
                  >
                    <img
                      src="/images/org-img/profile/add.png"
                      className="w-100"
                    />{" "}
                  </a>
                </span>
              )}
            </h4>
            <div className="languages-wrapper">
              {awardList?.map((awards, index) => {
                return (
                  <div key={index}  className="languages-item on-hover-icon">
                    <div className="icon-wrap">
                      {awards?.awardImage ? (
                        <LazyImage src={awards?.awardImage} />
                      ) : (
                        <LazyImage src="/images/org-img/awards/1.png" />
                      )}
                    </div>
                    <div className="meta">
                      <span className="dark-inverted">{awards?.AwardName}</span>
                      <span>{new Date(awards?.Date).getFullYear()}</span>
                    </div>
                    <div
                      className="hover-badges-box"
                      style={{ marginLeft: "auto" }}
                    >
                      {update && (
                        <button
                          onClick={() => editawards(awards)}
                          className="skill-actionbtn"
                          title="Edit"
                          data-bs-toggle="modal"
                          data-bs-target="#award"
                        >
                          <img src="/images/org-img/edit.png" />
                        </button>
                      )}
                      {deleted && (
                        <button
                          onClick={() => {
                            handleCreatedlstDelete(awards?.id);
                            GetMasterSystemAlertList("Delete_Award", 1);
                          }}
                          className="skill-actionbtn"
                          title="Delete"
                          data-bs-toggle="modal"
                          data-bs-target="#delete-Award"
                        >
                          <img src="/images/org-img/delete.png" />
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
              <div></div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="delete-Award">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>{deleteContent}</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                onClick={() => DeleteOrgAwardsAward()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};
export default UserAward;
